var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.errorMessage)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.errorMessage))]):(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):(_vm.digitalBook)?_c('flip-book',{attrs:{"digital-book":_vm.digitalBook}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }